import { AbstractAdapter } from "@app/shared/models/adapter.model";

export const DocumentPlusTypeKeys = {
  Audio: "AUDIO"
};

export enum DescriptionToUse {
  InBasket,
  DocumentType
}

export interface DocumentsPlus {
  id: number;
  description: string;
  type: string;
}

export interface DocumentsPlusFileDrag {
  dropLocation: DocumentsPlus;
  dropData: DocumentsPlus;
}

/**
 * Interface for PDF url web service
 */
export interface DocumentsPlusView {
  uniqueId: string;
  url?: string;
}

export interface DocumentsPlusAttachParms {
  ids: string[];
  applicationId: string;
  company?: string;
  index?: string;
  documentType?: string;
  documentTypeDescription?: string;
  selectedText?: string;
  autoAttach?: boolean; // attach behind the scenes. Do not prompt user
  isWebFace?: boolean; // Message from webface screen. Alters screen and behavior
  reportsPlus?: boolean; // reportsplus document
  disabled?: boolean;
  title?: string; // override title
}

export interface DocumentsPlusIndex {
  company: string;
  index: string;
}

export interface DocumentsPlusAttachSelect {
  title: string;
  subtitle: string;
  value: any;
}

/**
 * Data adapter for In Basket view document
 */
export class DocumentsPlusViewDocumentAdapter extends AbstractAdapter<DocumentsPlusView> {
  adapt(rawData: DocumentsPlusView) {
    return rawData;
  }
}
